import { Component, ElementRef, HostListener, inject, Renderer2 } from '@angular/core';
import { InputFocusDirective } from '../../directives/input.focus.directive';
import { FormBuilder, ReactiveFormsModule, FormGroup, FormControl, Validators } from '@angular/forms';  // <-- Import here
import { ApiService } from '../../utilities/api.service';
import { environment } from '../../../environments/environment';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { CommonApiService } from '../../services/commonapi.service';
import { ToastComponent } from '../toast/toast.component';
import { InputMaskDirective } from '../../directives/inputMask.directive';
import { RestrictCopyPasteDirective } from '../../directives/RestrictCopyPaste.directive';
import { DomSanitizer } from '@angular/platform-browser';
import { CommonHelperService } from '../../services/commonhelper.service';
import { RouterModule } from '@angular/router';
import { RedirectionService } from '../../services/redirection.service';
import { selectBoxHide, selectBoxInput, selectBoxOption } from '../../utilities/selectBox.utilities';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { ModalDirective } from '../../directives/modal.open.directive';
import { CongratulationPopupComponent } from "../congratulation-popup/congratulation-popup.component";
import { ModalService } from '../../services/modal.service';


@Component({
    selector: 'app-simple-form',
    imports: [InputFocusDirective, ReactiveFormsModule, CommonModule, NgOptimizedImage, ToastComponent,
        InputMaskDirective, RestrictCopyPasteDirective, RouterModule, NgScrollbarModule, CongratulationPopupComponent],
    templateUrl: './simple-form.component.html',
    styleUrl: './simple-form.component.scss',
    standalone: true,
})
export class SimpleFormComponent {
    assetsCDNUrl = environment.assetsCDNUrl;
    contactUsForm: FormGroup;
    queryCaptchaAsString: any;
    queryCaptcha: any;
    successMessage: any;
    errorMessage: any;
    message: any = "Your email subscription has been successfully submitted.";
    showToastSuccess: boolean = false;
    showToastFailure: boolean = false;
    _redirection = inject(RedirectionService);
    objective: any;
    constructor(private formBuilder: FormBuilder, private el: ElementRef, private _apiService: ApiService
        , private _commonApiService: CommonApiService, private sanitizer: DomSanitizer, private commonHelperService: CommonHelperService
        , private renderer: Renderer2, private modalService: ModalService) {
        this.contactUsForm = this.formBuilder.group({
            name: ['', [Validators.required, Validators.minLength(3)]],
            email: ['', [Validators.required, Validators.pattern('^[a-zA-Z0-9._%+-]{2,}@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$'
            )]],
            phone_number: ['', [Validators.required, Validators.minLength(10), Validators.maxLength(10), Validators.pattern('^[5-9][0-9]{0,9}$')]],
            captcha_form: ['', [Validators.required, Validators.minLength(6)]],
            objective: [''],

        })
        if (typeof window != 'undefined') {
            this.generateCaptcha();
        }
    }

    onSubmit() {
        this.contactUsForm.markAllAsTouched();
        if (this.contactUsForm.invalid) {
            for (const key of Object.keys(this.contactUsForm.controls)) {
                if (this.contactUsForm.controls[key].invalid) {
                    const invalidControl = this.el.nativeElement.querySelector('[formcontrolname="' + key + '"]');
                    invalidControl.focus();
                    break;
                }
            }
            return;
        } else {
            this.submitData();
        }
    }

    async submitData() {
        let getValue = this.contactUsForm.value;
        const data = {
            "module": "enquiry",
            "action": "newEnquiry",
            "data": {
                "name": getValue.name,
                "email": getValue.email,
                "mobile": getValue.phone_number,
                "type": "home_callback",
                "callback_time": "2025-02-10 10:10:00",
                "auth_token": this.queryCaptchaAsString,
                "captcha": getValue.captcha_form,
                "objective": this.objective
            }
        };
        let response = await this._apiService.postApiDataWithEvents("productData/services", data);

        let checkIsSuccess = response.success || false;
        if (checkIsSuccess) {
            this.contactUsForm.reset();
            this.modalService.showModal("congrts");
            this.message = response.data.message || "The submission was successful."
            this.showToastSuccess = true;
            this.showToastFailure = false;
            this.contactUsForm.patchValue({
                "phone_number": ""
            })
            if (typeof window !== 'undefined') {
                const elements = document.querySelectorAll('.form-group');
                elements.forEach(element => {
                    this.renderer.removeClass(element, 'focused');
                });
            }
        } else {
            this.message = response.status.data.message || "OOPS!, Something went Wrong !"
            this.showToastSuccess = false;
            this.showToastFailure = true;
            this.contactUsForm.patchValue({
                "captcha_form": ""
            })
        }

        setTimeout(() => {
            this.showToastFailure = false;
        }, 5000);
        this.generateCaptcha();

    }

    async generateCaptcha() {
        let getQueryCaptcha = await this._commonApiService.generateCaptcha('home_callback');
        this.queryCaptchaAsString = getQueryCaptcha.data.captchaToken || null;
        let captcha = getQueryCaptcha.data.captchaValue || null;
        let getBlob = this.commonHelperService.getBlob(captcha)
        this.queryCaptcha = this.sanitizer.bypassSecurityTrustUrl(getBlob);
    }

    listdata = [
        {
            listtext: 'A callback from your dedicated wealth partner',
        },
        {
            listtext: 'A personalized discussion to understand your needs',
        },
        {
            listtext: 'Bespoke recommendations to enable you to achieve your financial goals',
        },
    ]

    handler_redirect(selectedTab: number) {
        this._redirection.solution.set(selectedTab);
        setTimeout(() => {
            this._redirection.handler_scroll('js-scrollContent');
        }, 500);
    }

    @HostListener('click') onDocumentClick() {
        selectBoxHide('show');
    }
    handler__selectInput($event: any) {
        selectBoxInput($event);
    }
    handler__selectBox($event: any) {
        $event.stopImmediatePropagation();
    }
    handler__selectOption($event: any, formType: any) {
        this.objective = ($event.target.innerHTML).trim();
        this.contactUsForm.patchValue({
            "objective": this.objective
        })
        selectBoxOption($event);
    }

    @HostListener('click', ['$event'])
    handleClick(event: Event) {
        const target = event.target as HTMLElement;
        const elementId = target.id ? (target.id).toLowerCase() : "";
        if (elementId == "close") {
            this.showToastSuccess = false;
            this.showToastFailure = false;
        }
        selectBoxHide('show');
    }

}
